import { render, staticRenderFns } from "./create-reason.vue?vue&type=template&id=3d692e3a"
import script from "./create-reason.vue?vue&type=script&lang=js"
export * from "./create-reason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports